import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../common/app.settings';
import { AuthenticationService } from '../../services/authentication.service';
import { SynologyService } from '../../services/synology.service';
import { PrivilegesService } from '../../services/privileges.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    providers: [PrivilegesService]
})
export class HomeComponent {
    greetings: string;
    picture: string;
    pictureBytes: any;
    intervallSet = false;

    constructor(private router: Router,
        private authService: AuthenticationService,
        private synologyService: SynologyService,
        private privilegesService: PrivilegesService,
        private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        if (this.privilegesService.isAuthorized('home')) {
            this.router.navigate(['/']);
        } else {
            this.router.navigate(['/questions']);
        }

        this.greetings = 'Welcome to MCR Ottensen Consulting e.K.';

        var currentUser = this.authService.getCurrentUser();
        if (currentUser !== undefined) {
            this.greetings = 'Hi ' + currentUser.firstname + ' ' + currentUser.lastname + '. ' + this.greetings;
        }

        this.picture = AppSettings.apiEndPoint + '/synology/campicture/4';

        this.synologyService.getCamPicture(4)
        .subscribe(result => {
            this.pictureBytes = this.sanitizer.bypassSecurityTrustHtml(result);
        });

        if (!this.intervallSet)
        {
            this.intervallSet = true;
            for (var i = 1; i < 99999; i++)
            {
                window.clearInterval(i);
            }
            setInterval(() => {
                $('#divPic').animate({opacity: 0}, 500);
                $('#divPic').html('<div id=divPic><img id="picCam" src="' + this.picture + "?time=" + new Date() + '" class="img-responsive" />');
                $('#divPic').animate({opacity: 1}, 500);
            }, 8000);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts